import { observer, useLocalObservable } from 'mobx-react';
import { useEffect, useRef } from 'react';

const RecaptchaBadge = observer(({ successCallback }) => {
  const badgeRef = useRef(null);
  const recaptchaContainerRef = useRef(null);

  const store = useLocalObservable(() => ({
    recaptchaLoaded: false,
    widgetId: null,
  }));

  useEffect(() => {
    window.recaptcha.instances[$(badgeRef.current).closest('form').attr('id')] =
      {
        toggle: () => loadRecaptchaAndExecute(),
      };

    if (window.grecaptcha) {
      createWidget();
    }

    return () => {
      if (store.recaptchaLoaded) {
        window.grecaptcha.reset(store.widgetId);
      }
    };
  }, []);

  const loadRecaptchaAndExecute = async () => {
    if (store.recaptchaLoaded) {
      window.grecaptcha.reset(store.widgetId);
      window.grecaptcha.execute(store.widgetId);
      return;
    }

    if (window.grecaptcha === undefined) {
      const script = document.createElement('script');

      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = async () => {
        await createWidget();
        window.grecaptcha.execute(store.widgetId);
      };
      document.body.appendChild(script);
    } else {
      await createWidget();
      window.grecaptcha.execute(store.widgetId);
    }
  };

  const createWidget = () =>
    new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        const widgetId = window.grecaptcha.render(
          recaptchaContainerRef.current,
          {
            sitekey: recaptchaV2SiteKey,
            size: 'invisible',
            badge: 'inline',
            callback: (token) => onCaptchaSuccess(token),
          }
        );

        store.recaptchaLoaded = true;
        store.widgetId = widgetId;
        resolve();
      });
    });

  const onCaptchaSuccess = (token) => {
    if (successCallback) successCallback(token);

    document.dispatchEvent(
      new CustomEvent('recaptchaSuccess', { detail: { token: token } })
    );
  };

  return (
    <div ref={badgeRef}>
      <input
        className='recaptcha_token'
        name='recaptcha[token]'
        type='hidden'
      />

      <div ref={recaptchaContainerRef} />
    </div>
  );
});

export default RecaptchaBadge;
